import { createSelector } from 'reselect';
import { get } from 'lodash';
import { USER_FLAGS } from 'config';

const getProfileSelector = (state) => state.profile;

export const getProfileData = createSelector(getProfileSelector, (profile) => profile.data);
export const getContractNumberSelector = createSelector(getProfileData, (profileData) => profileData.contractNumber);

export const getVerimatrixIdSelector = createSelector(getProfileData, (profileData) => profileData.verimatrixId);

export const getIsLoggedInSelector = createSelector(getProfileSelector, (profile) => profile.isLoggedIn);

export const getProfileId = createSelector(
  getProfileData,
  // we need user id for patch, not profile id
  (profileData) => get(profileData, ['users', 0, 'id']),
);

export const getUserEmailFromProfile = createSelector(
  getProfileData,
  // we need user id for patch, not profile id
  (profileData) => get(profileData, ['users', 0, 'contact', 'email']),
);

export const getParentalDataSelector = createSelector(
  (state) => state.parental,
  (parental) => parental.data,
);

export const getIsUsingDefaultPin = createSelector(getProfileSelector, (profile) => profile.isUsingDefaultPin);

export const getBalance = createSelector(getProfileData, (data) => data.balance?.balance ?? null);

export const getLoginData = createSelector(getProfileSelector, (profile) => profile.loginData);

export const getIsLifecellFlag = createSelector(
  getLoginData,
  (loginData) => loginData?.userFlag === USER_FLAGS.LIFECELL,
);
